import React from "react";
import { Div, CloseIcon } from "components/Base";

const RecordItem = ({ name, onClick, icon, ...props }) => (
  <Div
    onClick={onClick}
    display="row.space-between.center"
    mb={1}
    bra={1}
    py={2}
    px={2}
    {...props}
  >
    <Div flex={1} fs={1} fw={3} color="gray9" truncate>
      {name}
    </Div>
    {icon}
  </Div>
);

const SelectedItem = ({ name, id, onClick }) => {
  return (
    <RecordItem
      name={name}
      onClick={() => onClick({ id: id, isSelected: false })}
      style={{
        backgroundColor: "#FDE7CB"
      }}
      icon={<CloseIcon size={15} color="primary7" />}
    />
  );
};

export default SelectedItem;
